import React from 'react';
import { useTranslation } from 'react-i18next';
import _startCase from 'lodash/startCase';
import { StatTab } from '@m12s/component-library';
import { useSelector } from 'react-redux';

import { getArePartCountBucketsLoading } from 'lib/selectors/getPartCountBuckets';
import { CyclesTimeCounter } from 'components/TabsCommon/CycleTimeCounter';
import { TextMedia, LoadingStatTabLabel } from '../styled';

export const CyclesTab = () => {
  const { t } = useTranslation();
  const arePartCountBucketsLoading = useSelector(getArePartCountBucketsLoading);

  return (
    <StatTab
      id="cycle-tab"
      value="cycleTime"
      label={
        <LoadingStatTabLabel loading={arePartCountBucketsLoading}>
          <TextMedia max={60}>{_startCase(t('cycle'))}</TextMedia>
          <TextMedia min={60}>{_startCase(t('current cycle'))}</TextMedia>
        </LoadingStatTabLabel>
      }
      secondaryLabel={<CyclesTimeCounter />}
    />
  );
};
